// extracted by mini-css-extract-plugin
export default {"cart-items":"Cart_cart-items__sfT+y","total":"Cart_total__7e95E","actions":"Cart_actions__SPilX","button--alt":"Cart_button--alt__kpq2a","button":"Cart_button__eVdDG"};